var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.673 48.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .logo-1 {\r\n        fill: #7d7d7d;\r\n      }\r\n\r\n      .logo-2 {\r\n        fill: #6198fd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-40.671 -217.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5839",
    "data-name": "Path 5839",
    className: "logo-1",
    d: "M48.485,230.211H40.671l1.263-7.163h24.8l-1.263,7.163H57.656l-5.119,29.032H43.366Z",
    transform: "translate(0 -3.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5840",
    "data-name": "Path 5840",
    className: "logo-2",
    d: "M105.6,249.233h8.194l-4.5,25.5H101.1Z",
    transform: "translate(-35.761 -18.537)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    className: "logo-2",
    cx: 4.474,
    cy: 3.752,
    rx: 4.474,
    ry: 3.752,
    transform: "translate(69.338 223.951) rotate(-42.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5841",
    "data-name": "Path 5841",
    className: "logo-1",
    d: "M140.446,259.94q1.062-6.023,4.612-8.764t9.409-2.74a18.327,18.327,0,0,1,2.544.19q1.35.19,2.5.461l-1.129,6.4q-.984-.271-1.746-.407a12.021,12.021,0,0,0-2.011-.136,9.526,9.526,0,0,0-2.463.271,3.984,3.984,0,0,0-1.677.9,4.347,4.347,0,0,0-1.088,1.709,15.436,15.436,0,0,0-.7,2.713l-.363,2.062q-.536,3.039.329,4.287t3.8,1.248a17.111,17.111,0,0,0,2.108-.109q.86-.108,1.929-.326l-1.119,6.349q-1.243.272-2.713.461a21.094,21.094,0,0,1-2.665.19q-5.86,0-8.525-2.74t-1.6-8.764Z",
    transform: "translate(-58.523 -18.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5842",
    "data-name": "Path 5842",
    className: "logo-1",
    d: "M197.471,223.048h7.977l-3.416,19.372,7.717-8.682h8.791l-10.149,11.4,5.272,14.109h-8.845l-3.867-10.69-1.885,10.69h-7.977Z",
    transform: "translate(-89.01 -3.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5843",
    "data-name": "Path 5843",
    className: "logo-1",
    d: "M278.746,274.738H271.42l-.141-2.279q-.713.652-1.373,1.166a10.1,10.1,0,0,1-1.411.923,6.772,6.772,0,0,1-1.657.624,9.115,9.115,0,0,1-2.1.217,8.109,8.109,0,0,1-2.822-.461,4.589,4.589,0,0,1-2.048-1.465,5.522,5.522,0,0,1-1.06-2.6,11.8,11.8,0,0,1,.142-3.88l3.129-17.745h8.194l-2.66,15.086a5.6,5.6,0,0,0,0,2.768,1.5,1.5,0,0,0,1.583.868,2.619,2.619,0,0,0,1.392-.353,2.885,2.885,0,0,0,.959-.977,5.545,5.545,0,0,0,.6-1.384,15.785,15.785,0,0,0,.359-1.574l2.545-14.434h8.194Z",
    transform: "translate(-129.023 -18.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5844",
    "data-name": "Path 5844",
    className: "logo-1",
    d: "M345.073,261.855a23.206,23.206,0,0,1-1.642,5.616,12.945,12.945,0,0,1-2.478,3.744,8.836,8.836,0,0,1-3.108,2.089,9.59,9.59,0,0,1-3.479.651,7.416,7.416,0,0,1-3.155-.57,7.342,7.342,0,0,1-2.249-1.709L326.7,284.484h-7.977l6.382-36.195h7.108l.141,2.279a15.267,15.267,0,0,1,2.928-2.144,8,8,0,0,1,3.829-.787,8.373,8.373,0,0,1,3.232.6,4.974,4.974,0,0,1,2.332,2.008,8.633,8.633,0,0,1,1.135,3.717,21.329,21.329,0,0,1-.368,5.779Zm-7.967-1.9a9.438,9.438,0,0,0,.087-4.341A2.058,2.058,0,0,0,335,254.367a3,3,0,0,0-1.591.407,3.558,3.558,0,0,0-1.109,1.058,5.515,5.515,0,0,0-.7,1.492,14.436,14.436,0,0,0-.41,1.709l-.622,3.527a13.465,13.465,0,0,0-.193,1.709,4.659,4.659,0,0,0,.144,1.492,2.044,2.044,0,0,0,.682,1.058,2.191,2.191,0,0,0,1.421.407,3.125,3.125,0,0,0,2.723-1.438,10.69,10.69,0,0,0,1.464-4.151Z",
    transform: "translate(-164.539 -17.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5845",
    "data-name": "Path 5845",
    className: "logo-2",
    d: "M105.6,249.233h8.111a1.842,1.842,0,0,1,1.813,2.161l-2.091,11.861h-11.85l2.2-12.5A1.841,1.841,0,0,1,105.6,249.233Z",
    transform: "translate(-36.046 -18.537)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.svg";
export { ForwardRef as ReactComponent };